import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background: #fff;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 20px;
  position: relative;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;

  button {
    background-color: transparent;
    border: none;
    position: absolute;
    left: 18px;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;

    svg {
      width: 24px;
      height: 24px;
      color: var(--color-black-primary);
    }

    &:hover {
      opacity: 0.7;
    }
  }
`;

export const Title = styled.h4`
  color: var(--color-black-primary);
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
  margin: 0;
`;

/* Área da câmera — o SDK injeta vídeo e SVG dentro de #box-camera */
export const CameraSlot = styled.div`
  flex: 1;
  position: relative;
  width: 100%;
  background: #000;
  overflow: hidden;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 20px 16px;
  overflow-y: auto;
  min-height: 0;
`;

/* Container usado apenas quando o SDK está ativo (loading ou erro sem resultado) */
export const UnicoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: #f5f5f5;
  min-height: 0;

  /* SDK Unico injeta iframe/canvas dentro deste container */
  iframe,
  canvas,
  video {
    width: 100% !important;
    height: 100% !important;
    border-radius: 16px;
  }
`;

/* Tela idle: ilustração + instrução, sem ocupar toda a altura */
export const IdleState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 8px 0;
  width: 100%;
  text-align: center;
`;

export const IdleIllustration = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: #f0f5ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;

  svg {
    width: 52px;
    height: 52px;
    color: var(--color-blue-primary, #0056d6);
  }
`;

export const IdleTitle = styled.h5`
  color: var(--color-black-primary);
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px;
  text-align: center;
`;

export const IdleDescription = styled.p`
  color: #666;
  font-size: 14px;
  line-height: 20px;
  margin: 0 auto 32px;
  text-align: center;
  max-width: 260px;
`;

export const Loading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid #f0f0f0;
  border-top-color: var(--color-blue-primary, #0056d6);
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const LoadingText = styled.span`
  color: var(--color-black-primary);
  font-size: 14px;
`;

export const ErrorMessage = styled.p`
  color: var(--color-red-100);
  font-size: 12px;
  font-weight: 700;
  margin: 0;
  margin-top: 8px;
`;

export const ResultCard = styled.div`
  padding: 14px 16px;
  background-color: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ResultTitle = styled.strong`
  display: block;
  width: 100%;
  color: #15803d;
  font-weight: 600;
  margin: 0;
  font-size: 15px;
  line-height: 20px;
`;

export const ResultMessage = styled.span`
  display: block;
  width: 100%;
  color: #166534;
  font-size: 13px;
  line-height: 18px;
  margin: 0;
`;

export const LivenessStatus = styled.div`
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(22, 163, 74, 0.2);
  font-size: 13px;
  color: #166534;
`;

export const Preview = styled.img`
  width: min(220px, 70vw);
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  object-fit: cover;
  background: #000;
  border: 4px solid #000;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
`;

export const FooterButtons = styled.div`
  padding: 12px 20px 32px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;

  > button {
    width: 100%;
  }

  > button + button {
    margin-left: 0 !important;
    margin-top: 8px;
  }
`;

/* Mantidos para compatibilidade (loading spinner usa EmptyState) */
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  text-align: center;
`;

export const EmptyStateIcon = styled.svg`
  width: 48px;
  height: 48px;
  color: #d0d0d0;
`;

export const EmptyStateText = styled.p`
  color: #666;
  font-size: 14px;
  margin: 0;
`;
